require('./RAReimbursementView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @commons
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RAOneLineSymbolAmount = require('../../components/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');

// @components
const RALandingSuccess = require('../../components/RALandingSuccess/RALandingSuccess');
const RACard = require('../../components/RACard/RACard');
const RAAmountInputWithLabels = require('../../components/RAAmountInputWithLabels/RAAmountInputWithLabels');
const RAAccountBox = require('../../components/RAAccountBox/RAAccountBox');
const RAAccordionWizardStep = require('../../components/RAAccordionWizardStep/RAAccordionWizardStep');
const RAAccordionWizard = require('../../components/RAAccordionWizard/RAAccordionWizard');
const RAReimbursementModal = require('./RAReimbursementModal/RAReimbursementModal');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raReimbursementActions = require('../../actions/RAReimbursement');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const CurrencyHelper = require('utilities/currencyHelper');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');
const {
    showWarningMessage,
    getPorfolioOperationStatus,
} = require('../../utilities/RAStatusPortfolioOperationHelper');
const { getFirstNChars } = require('utilities/stringHelper');
const {
    recordLink,
    recordProcess,
    PROC_RA_REFUND,
    PROC_START,
} = require('utilities/tagging');
const { isTestExpired } = require('../../utilities/RASuitabilityTestHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const { EURO_SYMBOL, MYPROFILE_BROKER_URL } = require('constants/index');
const { EXPIRED_FLOW, BLOCKED_OTP } = require('constants/signaturePattern');
const {
    GO_BACK_URL,
    WIZARD_POSITION_FIRST,
    RA_REFUND_REQUEST_MIN,
    RA_REFUND_REQUEST_MIN_LABEL,
    MYPROFILE_BROKER_ROBO_URL,
    GOAL_TRACKING_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACKING_URL,
    PORTFOLIO_TRACK_URL_PARA,
    PROC_RA_CANCEL,
    PROC_RA_START,
    PROC_RA_REFUND_WALLET,
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
} = require('../../raConstants/index');

const { RA_REIMBURSEMENT } = require('utilities/tagging');

// @assets
const carImage = require('../../assets/icons/coche.png');
const travelImage = require('../../assets/icons/viaje.png');
const homeImage = require('../../assets/icons/casa.png');
const educationImage = require('../../assets/icons/educacion.png');
const otherImage = require('../../assets/icons/otro.png');

const buildAmountObject = amount => ({
    currency: EURO_SYMBOL,
    amount,
});

//@contact center
const {
    canFinishOperative,
} = require('../../utilities/contactCenter/RACanFinishOperativeHelper');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class RAReimbursementView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };

        this.handleCancelButton = this.handleCancelButton.bind(this);
        this.handleVerifyOTP = this.handleVerifyOTP.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setAmount = this.setAmount.bind(this);
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            immGlobalPosition,
            immReimbursementRequest,
            outdateMyInvestments,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        outdateMyInvestments();
        if (!immReimbursementRequest.get('investmentsFetched')) {
            fetchMyInvestments();
        }

        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const eventTag = 'robo cartera ' + selectedStrategy;
        const customData = {
            processDetail: eventTag,
        };
        this.modalOpen();
        recordProcess(PROC_RA_REFUND, PROC_START, customData);
        recordLink(PROC_RA_REFUND, PROC_RA_START, eventTag);
    }

    componentDidUpdate(prevProps) {
        const {
            immSignaturePattern,
            immGlobalPosition,
            immReimbursementRequest,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const prevSignaturePatternFetchedFlag = prevProps.immSignaturePattern.get(
            'isFetchingConfigSuccess',
        );
        const nextSignaturePatternFetchedFlag = immSignaturePattern.get(
            'isFetchingConfigSuccess',
        );
        const submitSuccessful = immReimbursementRequest.get(
            'submitSuccessful',
        );
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const eventTag = PROC_RA_REFUND_WALLET + selectedStrategy;
        const amount = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'amount',
        ]);
        const isSMSValid = immSignaturePattern.get('isSMSValid');
        const SignaturePatternRestartNotification = immSignaturePattern.get(
            'reasonForRestart',
        );
        const SMSError = immSignaturePattern.get('isFetchingSMSCodeError');

        if (
            prevProps.immSignaturePattern.get('isFetchingSMSCode') &&
            !immSignaturePattern.get('isFetchingSMSCode') &&
            immSignaturePattern.get('showWarningSMS')
        ) {
            let inputErrorMessage;
            if (!isSMSValid) {
                // SMS format is not valid. This validation is not active right now
                inputErrorMessage = formatText('signaturePattern-invalidSMS');
            } else if (!!SignaturePatternRestartNotification) {
                switch (SignaturePatternRestartNotification) {
                    case EXPIRED_FLOW:
                        inputErrorMessage = formatText(
                            'signaturePattern-expiredFlow',
                        );
                        break;
                    case BLOCKED_OTP:
                        inputErrorMessage = formatText(
                            'signaturePattern-blockedOTP',
                        );
                        break;
                }
            } else if (!!SMSError) {
                inputErrorMessage = formatText('signaturePattern-SMSRejected');
            }

            taggingEventHandled(RA_REIMBURSEMENT, 'consultOTPError', {
                amount,
                productName: eventTag,
                errorCategory: immSignaturePattern.get(
                    'isFetchingSMSDescriptionError',
                ),
                errorDescription: inputErrorMessage,
            });
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    closeModal() {
        if (this.state.showModal) {
            this.setState({
                showModal: false,
            });
        }
    }

    modalOpen() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        if (
            portfolioId &&
            immGlobalPosition.getIn(['portfolios', portfolioId, 'state'])
        ) {
            const immPortfolioState = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'state',
            ]);
            const tradingOnHold = immPortfolioState.get('tradingOnHold');
            const strategyChange = immPortfolioState.get('strategyChange');
            const monthlyRebalancing = immPortfolioState.get(
                'monthlyRebalancing',
            );

            if (
                showWarningMessage(
                    tradingOnHold,
                    strategyChange,
                    monthlyRebalancing,
                )
            ) {
                this.setState({
                    showModal: true,
                });
            }
        }
    }

    getBreadcrumb() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const origin = immGlobalPosition.get('originRedirection');
        let parentTitle;
        let parentUrl;
        if (origin === PORTFOLIO_TRACK_URL_PARA) {
            parentTitle = formatText(
                'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
            );
            parentUrl = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
        } else if (origin === OBJECTIVE_TRACK_URL_PARA) {
            parentTitle = formatText('breadcrumb-breadcrumb_objectiveTracking');
            parentUrl = `${GOAL_TRACKING_URL}/${portfolioId}`;
        }
        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('raReimbursement-managementBreadcrumb'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            ...(origin === PORTFOLIO_TRACK_URL_PARA ||
            origin === OBJECTIVE_TRACK_URL_PARA
                ? [
                      {
                          text: parentTitle,
                          url: parentUrl,
                      },
                  ]
                : []),
            {
                text: formatText('raReimbursement-refundRequestBreadcrumb'),
            },
        ];
    }

    getGoalIconImage(goalType) {
        switch (goalType) {
            // @Temporally logic, TODO: change RACircularProgressIcon to implement as modifier class
            case 'CAR':
                return carImage;
            case 'TRAVEL':
                return travelImage;
            case 'HOME':
                return homeImage;
            case 'EDUCATION':
                return educationImage;
            case 'OTHERS':
                return otherImage;
            default:
                return '';
        }
    }

    buildAmountErrorMessage(amount, max) {
        if (amount < RA_REFUND_REQUEST_MIN) {
            const formattedMinAmount = CurrencyHelper.formatAmount(
                RA_REFUND_REQUEST_MIN_LABEL,
            );
            return formatText('raReimbursement-minAmountErrorLabel', [
                formattedMinAmount,
            ]);
        } else if (amount > max) {
            const formattedMaxAmount = CurrencyHelper.formatAmount(max);
            return formatText('raReimbursement-maxAmountErrorLabel', [
                formattedMaxAmount,
            ]);
        }
    }

    getProductIcon() {
        const { immReimbursementRequest } = this.props;
        const product = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'typeOfProduct',
        ]);
        if (!product) {
            return false;
        }
        return Portfolios[product].iconLine;
    }

    getCurrentPortfolio() {
        const { immGlobalPosition, match } = this.props;
        const trackingPortfolioId = match.params.portfolioId;
        return immGlobalPosition.getIn(['portfolios', trackingPortfolioId]);
    }

    getPortfolioName(immPortfolio) {
        let portfolioName;
        if (immPortfolio) {
            portfolioName = immPortfolio.get('hasGoal')
                ? immPortfolio.getIn(['goalInformation', 'name'])
                : immPortfolio.get('name');
        }
        return portfolioName;
    }

    getPortfolioIcon(immPortfolio) {
        const portfolioHasGoal = immPortfolio.get('hasGoal');
        if (portfolioHasGoal) {
            const goalType = immPortfolio.getIn([
                'goalInformation',
                'goalType',
            ]);
            return this.getGoalIconImage(goalType);
        } else {
            const productCode = immPortfolio.getIn([
                'product',
                'typeOfProduct',
            ]);
            return Portfolios[productCode].iconLine;
        }
    }

    tagReimbursementEvent(type) {
        const {
            immReimbursementRequest,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const amount = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'amount',
        ]);
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const portfolioName = PROC_RA_REFUND_WALLET + selectedStrategy;

        taggingEventHandled(RA_REIMBURSEMENT, type, {
            amount: amount,
            productName: portfolioName,
        });
    }

    handleCancelButton() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        recordLink(
            PROC_RA_REFUND,
            PROC_RA_CANCEL,
            PROC_RA_REFUND_WALLET + selectedStrategy,
        );
    }

    handleVerifyOTP() {
        const {
            history,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        this.tagReimbursementEvent('reimbursementConfirm');
        this.props.finish(history, portfolioId);
    }

    buildOTPSection() {
        const {
            immGlobalPosition,
            immReimbursementRequest,
            finish,
            reset,
            setReimbursementRequestAmount,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const operationParams = {}; // TBD
        // TODO: Operation type based on PropuestaSeguridadOperativa_v4.9 https://files.slack.com/files-pri/T7D8L6UNT-FAD88M3N1/download/propuestaseguridadoperativa_v4.9__1_.xlsx
        //  TODO: Update to operation type 219 (currently not working) based on PropuestaSeguridadOperativa_v5.0. https://files.slack.com/files-pri/T7D8L6UNT-FAE26M0ET/download/propuestaseguridadoperativa_v5.0__3_.xlsx
        const operationType = 159;
        const immPortfolio = this.getCurrentPortfolio();
        const amountIsDirty = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'isDirty',
        ]);
        const amount = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'amount',
        ]);
        const netValue = immPortfolio.getIn([
            'keyFigures',
            'maxWithdrawalAmount',
        ]);
        const amountError = amountIsDirty
            ? amount < RA_REFUND_REQUEST_MIN || amount > netValue
            : false;
        const portfolioHasGoal = immPortfolio.get('hasGoal');
        const printTitleValue = portfolioHasGoal
            ? 'roboPrintTitle-refundGestionOjbetives'
            : 'roboPrintTitle-refundGestionDiscretion';

        if (!amountError && amountIsDirty && netValue > 0) {
            return (
                <RACard
                    extraClass="ra-reimbursement-view__otp-card no-print-out"
                    titleKey="raReimbursement-otpTitle"
                    iconClass="icon-firma"
                    active={!amountError || !amountIsDirty}
                >
                    <SignaturePattern
                        printTitleValue={printTitleValue}
                        customClassName="ra-reimbursement-view__signature-pattern"
                        operationType={operationType}
                        operationParams={operationParams}
                        displayTitle={false}
                        onSMSInputClick={() =>
                            this.tagReimbursementEvent('focusOTPBox')
                        }
                        onResendClick={() => {
                            this.tagReimbursementEvent('resetOTP');
                        }}
                    />
                </RACard>
            );
        } else {
            return (
                <RAAccordionWizard
                    immSteps={immReimbursementRequest.get('steps')}
                    cancelPath={MYPROFILE_BROKER_ROBO_URL}
                    finish={finish}
                    resetStep={reset}
                    validateStep={setReimbursementRequestAmount}
                >
                    <RAAccordionWizardStep
                        position={WIZARD_POSITION_FIRST}
                        title={formatText('raReimbursement-otpTitle')}
                        icon="icon-imprevistos"
                        valid={false}
                        disabled={true}
                        hideNextButton={true}
                    >
                        <SignaturePattern
                            printTitleValue={printTitleValue}
                            customClassName="ra-reimbursement-view__signature-pattern"
                            operationType={operationType}
                            operationParams={operationParams}
                            displayTitle={false}
                            onSMSInputClick={() =>
                                this.tagReimbursementEvent('focusOTPBox')
                            }
                            onResendClick={() => {
                                this.tagReimbursementEvent('resetOTP');
                            }}
                        />
                    </RAAccordionWizardStep>
                </RAAccordionWizard>
            );
        }
    }

    buildLegalTextSection() {
        if (!__CONTACT_CENTER__) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="ra-reimbursement-view__legal-text-section">
                        <BlockInfo extraClass="ra-reimbursement-view__legal-text-info-block">
                            <div className="ra-reimbursement-view__legal-text-info-block-content">
                                <FormattedText
                                    className="ra-reimbursement-view__legal-text"
                                    value="raReimbursement-legalText"
                                />
                            </div>
                        </BlockInfo>
                    </div>
                </div>
            </div>
        );
    }

    setAmount(amount) {
        const {
            setReimbursementRequestAmount,
            immReimbursementRequest,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const immPortfolio = this.getCurrentPortfolio();
        const netValue = immPortfolio.getIn([
            'keyFigures',
            'maxWithdrawalAmount',
        ]);
        const isNotValidAmount =
            amount < RA_REFUND_REQUEST_MIN || amount > netValue;

        const immReimbursementDetails = immReimbursementRequest.get(
            'reimbursementDetails',
        );
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'name',
        ]);
        const portfolioName = PROC_RA_REFUND_WALLET + selectedStrategy;

        if (
            (!immReimbursementDetails && !!amount) ||
            (!!immReimbursementDetails &&
                immReimbursementDetails.get('amount') !== amount)
        ) {
            if (!isNotValidAmount) {
                taggingEventHandled(RA_REIMBURSEMENT, 'setValidAmount', {
                    portfolioName: portfolioName,
                    amount: amount,
                    productName: portfolioName,
                });
            } else {
                if (amount < RA_REFUND_REQUEST_MIN) {
                    const formattedMinAmount = CurrencyHelper.formatAmount(
                        RA_REFUND_REQUEST_MIN_LABEL,
                    );
                    taggingEventHandled(RA_REIMBURSEMENT, 'setInvalidAmount', {
                        portfolioName: portfolioName,
                        amount: amount,
                        productName: portfolioName,
                        errorCategory: formatText(
                            'raReimbursement-minAmountErrorLabel',
                            [formattedMinAmount],
                        ),
                    });
                } else {
                    const formattedMaxAmount = CurrencyHelper.formatAmount(
                        netValue,
                    );
                    taggingEventHandled(RA_REIMBURSEMENT, 'setInvalidAmount', {
                        portfolioName: portfolioName,
                        amount: amount,
                        productName: portfolioName,
                        errorCategory: formatText(
                            'raReimbursement-maxAmountErrorLabel',
                            [formattedMaxAmount],
                        ),
                    });
                }
            }
        }
        setReimbursementRequestAmount(amount);
    }

    buildWizardSection() {
        const {
            immReimbursementRequest,
            immPrinter,
            immProfileFields,
            immSignaturePattern,
        } = this.props;
        const owner = immProfileFields.get('fullname');
        const immPortfolio = this.getCurrentPortfolio();
        const amountIsDirty = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'isDirty',
        ]);
        const amount = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'amount',
        ]);
        const currentValue = immPortfolio.getIn(['keyFigures', 'valuation']);
        const netValue = immPortfolio.getIn([
            'keyFigures',
            'maxWithdrawalAmount',
        ]);
        const formattedMinAmount = CurrencyHelper.formatAmount(
            RA_REFUND_REQUEST_MIN_LABEL,
        );
        const formattedMaxAmount = CurrencyHelper.formatAmount(netValue);

        const isRefundAllowed = netValue > 10;

        const minLabel = (
            <FormattedText
                injectedStrings={[formattedMinAmount]}
                value="raRefundRequest-minAmountLabel"
            />
        );
        const maxLabel = isRefundAllowed ? (
            <FormattedText
                injectedStrings={[formattedMaxAmount]}
                value="raRefundRequest-maxAmountLabel"
            />
        ) : null;
        const amountError = amountIsDirty
            ? amount < RA_REFUND_REQUEST_MIN || amount > netValue
            : false;
        const amountErrorMessage = this.buildAmountErrorMessage(
            amount,
            netValue,
        );
        const refundInfo = formatText('raRefundRequest-refundInfo');
        const otpSection = this.buildOTPSection();
        const canContinue = !__CONTACT_CENTER__
            ? !!immSignaturePattern.get('inputValueSMS') ||
              !!immSignaturePattern.get('consumerFinishInputDigits')
            : canFinishOperative(immSignaturePattern, immPrinter);
        const amountInputInfoSection = (
            <div className={'ra-reimbursement-view__section-card no-print-out'}>
                {!isRefundAllowed ? (
                    <div>
                        <FormattedText value="raRefundRequest-maxWithdrawalLimitWarning" />
                    </div>
                ) : null}
                {refundInfo}
            </div>
        );
        const legalTextSection = this.buildLegalTextSection();

        let iconType, goalModifier;
        if (immPortfolio.get('hasGoal')) {
            const goalDate = immPortfolio.getIn([
                'goalInformation',
                'goalDate',
            ]);
            const goalProgress = immPortfolio.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalNotReached =
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day');
            const goalReached = goalProgress >= 1;

            if (goalReached || goalNotReached) {
                iconType = immPortfolio
                    .getIn(['goalInformation', 'goalType'])
                    .toLowerCase();
                goalModifier = goalReached
                    ? RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS
                    : RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
            }
        }

        return (
            <div>
                <div className="ra-reimbursement-view__wizard">
                    <RAAccountBox
                        goalModifier={goalModifier}
                        accountOwner={owner}
                        currentValue={currentValue}
                        productName={this.getPortfolioName(immPortfolio)}
                        productIcon={this.getPortfolioIcon(immPortfolio)}
                        iconType={iconType}
                    />
                    <RACard
                        active={true}
                        iconClass="icon-imprevistos"
                        titleKey="raRefundRequest-refundAmount"
                        checked={!amountError && amountIsDirty}
                        extraClass="ra-reimbursement-view__amount-section"
                    >
                        <div>
                            <RAAmountInputWithLabels
                                error={amountError}
                                errorMsg={amountErrorMessage}
                                unit={EURO_SYMBOL}
                                amount={amount}
                                minLabel={minLabel}
                                maxLabel={maxLabel}
                                disabled={!isRefundAllowed}
                                callback={this.setAmount}
                                showBlurZero
                            />
                        </div>
                        {amountInputInfoSection}
                    </RACard>
                    {legalTextSection}
                    <div className="row">
                        <div className="col-xs-12">{otpSection}</div>
                    </div>
                    <div className="ra-reimbursement-view__info-container no-print-out">
                        <FormattedText
                            value="raReimbursement-info"
                            className="ra-reimbursement-view__info"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <RAFooter
                            cancelPath={GO_BACK_URL}
                            onLeftButtonClick={this.handleCancelButton}
                            onRightButtonClick={this.handleVerifyOTP}
                            disableRightButton={!canContinue}
                            rightButtonText={formatText(
                                'raRefundRequest-ctaConfirm',
                            )}
                            showRightContent={true}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildSuccessfulSection() {
        const {
            immReimbursementRequest,
            immProfileFields,
            immSuitabilityTest,
        } = this.props;
        const owner = immProfileFields.get('fullname');
        const currentPortfolio = this.getCurrentPortfolio();
        const portfolioName = this.getPortfolioName(currentPortfolio);
        const actualValue = currentPortfolio.getIn(['keyFigures', 'valuation']);
        const reimbursementAmount = immReimbursementRequest.getIn([
            'reimbursementDetails',
            'amount',
        ]);
        const profileInvestor = immSuitabilityTest.getIn([
            'results',
            0,
            'clientRiskProfileTitle',
        ]);
        const postReimbursementValue = actualValue - reimbursementAmount;
        const actualValueFormatted = (
            <RAOneLineSymbolAmount
                amountObject={buildAmountObject(actualValue)}
            />
        );
        const reimbursementValueFormatted = (
            <RAOneLineSymbolAmount
                amountObject={buildAmountObject(reimbursementAmount)}
            />
        );
        const postReimbursementValueFormatted = (
            <RAOneLineSymbolAmount
                amountObject={buildAmountObject(postReimbursementValue)}
            />
        );
        const resumeContent = [
            {
                label: formatText('raCancelPlan-resumeAccount'),
                value: getFirstNChars(portfolioName, 20),
            },
            {
                label: formatText('raCancelPlan-resumeOwner'),
                value: owner,
            },
            {
                label: formatText('raCancelPlan-resumeValue'),
                value: actualValueFormatted,
            },
            {
                label: formatText('raReimbursement-resumeDestiny'),
                value: formatText('raReimbursement-resumeDestinyValue'),
            },
            {
                label: formatText('raRefundRequest-refundAmount'),
                value: reimbursementValueFormatted,
            },
            {
                label: formatText('raRefundRequest-postRefundAmount'),
                value: postReimbursementValueFormatted,
            },
        ];
        const resumeTitle = formatText('raRefundRequest-newRefund');
        const mainButton = formatText('raReimbursement-mainButton');
        const infoContent = formatText('raRefundRequest-infoText');
        return (
            <RALandingSuccess
                title={resumeTitle}
                resumeContent={resumeContent}
                info={infoContent}
                mainButton={mainButton}
                mainButtonURL={MYPROFILE_BROKER_ROBO_URL}
                onRender={() =>
                    window &&
                    window.utag &&
                    window.utag.view &&
                    window.utag.view({ reimbursementAmount, profileInvestor })
                }
            />
        );
    }

    buildModal(tradingOnHold, strategyChange, monthlyRebalancing) {
        const {
            cancelModifyPlanModal,
            immCheckStatus,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        const testExpired = isTestExpired(immCheckStatus);

        const hasGoal = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'hasGoal',
        ]);
        const hasGoalKey = hasGoal ? 'Goal' : 'Portfolio';

        const status = getPorfolioOperationStatus(
            tradingOnHold,
            strategyChange,
            monthlyRebalancing,
        );

        const titleKey = `raReimbursement-modalOperationStatus_title${status}`;
        const contentKey1 = `raReimbursement-modalOperationStatus_content${hasGoalKey}${status}1`;
        const contentKey2 = `raReimbursement-modalOperationStatus_content${hasGoalKey}${status}2`;
        const linkTextKey = `raReimbursement-modalOperationStatus_link${status}`;
        const buttonTextKey = `raReimbursement-modalOperationStatus_buttonText${status}`;

        let modalData = {
            title: titleKey,
            linkText: linkTextKey,
            content1: contentKey1,
            content2: contentKey2,
            buttonText: buttonTextKey,
        };

        if (__CONTACT_CENTER__) {
            switch (status) {
                case 'OrderInProgress':
                case 'RebalancingByCommittee':
                case 'StrategyChangeInProgress':
                    const contentKey3 = `raReimbursement-modalOperationStatus_content${hasGoalKey}${status}3`;
                    modalData = {
                        ...modalData,
                        content3: contentKey3,
                    };
                    break;
                case 'NoOrdersNoRebalancing':
                default:
                    break;
            }
        }
        const modalUrl = `/myprofile/robo/modifyPlan/${portfolioId}`;

        return (
            <RAReimbursementModal
                showModal={this.state.showModal}
                modalUrl={modalUrl}
                modalData={modalData}
                closeModal={this.closeModal}
                cancelModifyPlanModal={cancelModifyPlanModal}
                isTestExpired={testExpired}
            />
        );
    }

    render() {
        const {
            immReimbursementRequest,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const submitSuccessful = immReimbursementRequest.get(
            'submitSuccessful',
        );
        const breadcrumb = this.getBreadcrumb();
        let content;

        if (submitSuccessful) {
            content = this.buildSuccessfulSection();
        } else {
            content = immReimbursementRequest.get('investmentsFetched') ? (
                this.buildWizardSection()
            ) : (
                <LoadingSection />
            );
        }

        let modalSection;
        if (
            portfolioId &&
            immGlobalPosition.getIn(['portfolios', portfolioId, 'state'])
        ) {
            const immPortfolioState = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'state',
            ]);
            const tradingOnHold = immPortfolioState.get('tradingOnHold');
            const strategyChange = immPortfolioState.get('strategyChange');
            const monthlyRebalancing = immPortfolioState.get(
                'monthlyRebalancing',
            );

            modalSection = showWarningMessage(
                tradingOnHold,
                strategyChange,
                monthlyRebalancing,
            )
                ? this.buildModal(
                      tradingOnHold,
                      strategyChange,
                      monthlyRebalancing,
                  )
                : null;
        }

        return (
            <div className="ra-reimbursement-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={breadcrumb}
                            success={submitSuccessful}
                            successTitle={formatText(
                                'raRefundRequest-headerSuccessTitle',
                            )}
                            title={formatText('raRefundRequest-headerTitle')}
                        />
                    </div>
                </div>
                {modalSection}
                <div
                    id="printable-wizard"
                    className="row ra-reimbursement-view__container"
                >
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">{content}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAReimbursementView.propTypes = {
    cancelModifyPlanModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object,
    immReimbursementRequest: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    outdateMyInvestments: PropTypes.func.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    setReimbursementRequestAmount: PropTypes.func.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immPrinter: state.printer,
        immProfileFields: state.profile,
        immReimbursementRequest: state.raReimbursement,
        immGlobalPosition: state.raGlobalPosition,
        immSignaturePattern: state.signaturePattern,
        immCheckStatus: state.raCheckStatus,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    {
        cancelModifyPlanModal:
            portfolioDistributionActions.cancelModifyPlanModal,
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        outdateMyInvestments: brokerMyInvestments.outdateMyInvestments,
        finish: raReimbursementActions.finish,
        reset: raReimbursementActions.reset,
        setReimbursementRequestAmount:
            raReimbursementActions.setReimbursementRequestAmount,
    },
)(withRouter(RAReimbursementView));
